var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen-container"},[(!_vm.showYinliao)?_c('iframe',{staticClass:"fullscreen-iframe",attrs:{"src":"/zhihuixinli.html","frameborder":"0"}}):_c('iframe',{staticClass:"fullscreen-iframe",attrs:{"src":"/yinliao.html","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }